// extracted by mini-css-extract-plugin
module.exports = {"warp":"CollectCoupons_warp__oqrsp"};